export default __webpack_public_path__ + "static/media/dgt_bulk-plant.e23f32f9.png";